import { render, staticRenderFns } from "./PlatformGuide.vue?vue&type=template&id=6c41417d&scoped=true"
import script from "./PlatformGuide.vue?vue&type=script&lang=js"
export * from "./PlatformGuide.vue?vue&type=script&lang=js"
import style0 from "./PlatformGuide.vue?vue&type=style&index=0&id=6c41417d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c41417d",
  null
  
)

export default component.exports